export default "__VITE_ASSET__DnE$YpDl__"